import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import QRCode from 'qrcode';
import { API_BASE } from './config';
import '../css/GroupJoinQrModal.css';

export default function GroupJoinQrModal({ group, onClose, mode = 'checkin' }) {
  const [qrImage, setQrImage] = useState('');
  const [joinUrl, setJoinUrl] = useState('');
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        if (mode === 'monitor') {
          const url = `${window.location.origin}/monitor/${group.id}`;
          const image = await QRCode.toDataURL(url, {
            width: 420, margin: 2,
            color: { dark: '#102a43', light: '#ffffff' },
            errorCorrectionLevel: 'M'
          });
          if (active) { setJoinUrl(url); setQrImage(image); }
          return;
        }
        const response = await fetch(`${API_BASE}/api/checkin/join/${group.id}/qr-code`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.message || 'สร้าง QR ไม่สำเร็จ');
        const url = `${window.location.origin}/join/${group.id}?code=${encodeURIComponent(data.code)}`;
        const image = await QRCode.toDataURL(url, {
          width: 420, margin: 2,
          color: { dark: '#102a43', light: '#ffffff' },
          errorCorrectionLevel: 'M'
        });
        if (active) { setJoinUrl(url); setQrImage(image); }
      } catch (loadError) {
        if (active) setError(loadError.message);
      }
    };
    load();
    return () => { active = false; };
  }, [group.id, mode]);

  useEffect(() => {
    const closeOnEscape = event => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [onClose]);

  const copyLink = async () => {
    await navigator.clipboard.writeText(joinUrl);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return createPortal(
    <div className="group-qr-backdrop" onMouseDown={onClose}>
      <section className="group-qr-modal" onMouseDown={event => event.stopPropagation()}>
        <header>
          <div><small>{mode === 'monitor' ? 'QR MATCH MONITOR' : 'QR CHECK-IN'}</small><h2>{group.Group_Name}</h2></div>
          <button type="button" onClick={onClose}>×</button>
        </header>
        {error ? <div className="group-qr-error">{error}</div> : !qrImage ? (
          <div className="group-qr-loading">กำลังสร้าง QR…</div>
        ) : <>
          <div className="group-qr-image"><img src={qrImage} alt={`QR ${mode === 'monitor' ? 'Monitor' : 'Join'} ${group.Group_Name}`} /></div>
          <p>{mode === 'monitor'
            ? 'สแกนเพื่อเปิดหน้า Monitor ดู Match เท่านั้น จะไม่ Check-in เข้า Group'
            : 'ให้สมาชิกสแกนเพื่อค้นหาชื่อ Login และ Check-in เข้า Group นี้'}</p>
          <code>{joinUrl}</code>
          <div className="group-qr-actions">
            <button type="button" onClick={copyLink}>{copied ? '✓ คัดลอกแล้ว' : '🔗 คัดลอกลิงก์'}</button>
            <a href={qrImage} download={`${mode === 'monitor' ? 'monitor' : 'join'}-${group.Group_Name}-qr.png`}>⬇ ดาวน์โหลด QR</a>
          </div>
        </>}
      </section>
    </div>,
    document.body
  );
}
